import { DEGTORAD, markers, RADTODEG, Shell } from "./simulation"
import { addEvent, events, RadioEvent} from "./events"
import { reloaded, unloadShell } from "./crank"
import { grid_count, grid_size, pixels_to_km, player_x, player_y, start_p } from "./constants"
import { startCampaign } from "./stressometer"
import { IUnit, units } from "./units"
import { checkForMessages, radioUnit } from "./radio"

const fire_in = document.getElementById("fire-in") as HTMLInputElement

const yangle_out = document.getElementById("yangle-out") as HTMLSpanElement
const xzangle_out = document.getElementById("xzangle-out") as HTMLSpanElement


const canvas = document.getElementById("map") as HTMLCanvasElement
const ctx = canvas.getContext("2d") as CanvasRenderingContext2D

const shells:Shell[] = []

const keys : {[key: string]:boolean} = {};
let shift = false;

document.addEventListener("keydown", function (event) {
    shift = event.shiftKey;
    keys[event.key] = true;
});
document.addEventListener("keyup", function (event) {
    shift = event.shiftKey;
    keys[event.key] = false;
});


function draw(){
    ctx.clearRect(0, 0, 1000, 1000)

    ctx.strokeStyle = "grey"
    for(let x = 0; x < grid_count; x++){
        for(let y = 0; y < grid_count; y++){
            ctx.strokeRect(x * grid_size + start_p, y * grid_size + start_p, grid_size, grid_size)
        }
    }
    ctx.strokeStyle = "black"
    ctx.font = "16px arial"
    for(let x = 0; x < grid_count; x++){
        ctx.fillText((x + 1).toString(), start_p + (x + 0.5) * grid_size, 15)
    }
    for(let y = 0; y < grid_count; y++){
        ctx.fillText(String.fromCharCode(97+y), 0, start_p + (y + 0.5) * grid_size)
    }


    ctx.beginPath();
    ctx?.arc(player_x, player_y, 5, 0, 360);
    ctx.stroke();
    
    ctx.beginPath();
    ctx?.arc(player_x, player_y, 100, 0, 360);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(player_x, player_y)
    ctx.lineTo(player_x + Math.cos(yangle) * 50, player_y + Math.sin(yangle) * 50)
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.lineWidth = 1;



    for(const shell of shells){
        shell.draw(ctx);
    }
    for(const marker of markers){
        marker.draw(ctx);
    }
    for(const unit of units){
        if(unit.unit.colour == "red"){
            unit.draw(ctx);
        }
    }

    
    ctx.beginPath();
    ctx.moveTo(0, 0)
    ctx.lineTo(0, 800)
    ctx.lineTo(800, 800)
    ctx.lineTo(800, 0)
    // ctx.moveTo(player_x, player_y)
    // ctx.arc(player_x, player_y, 100, 0, 360)
    if(radioUnit){
        ctx.moveTo(radioUnit.unit.x, radioUnit.unit.z)
        ctx.arc(radioUnit.unit.x, radioUnit.unit.z, 150, 0, 360)
        console.log(radioUnit.unit.z)
        if(radioUnit.unit.z < 500){
            ctx.moveTo(player_x, player_y)
            ctx.arc(player_x, player_y, 100, 0, 360)
        }
    }else{
        ctx.moveTo(player_x, player_y)
        ctx.arc(player_x, player_y, 100, 0, 360)
    }
    ctx.fillStyle = "#dddddd";
    ctx.fill("evenodd");

    
    for(const unit of units){
        if(unit.unit.colour == "green"){
            unit.draw(ctx);
        }
    }
}

let yangle = 0; //In radians
let xzangle = 0; //In radians
function handleMovement(delta:number){
    const multiplier = (shift ? 0.3 : 1.5) * delta;
    if(keys["ArrowUp"]){
        xzangle += multiplier * 0.2;
    }
    if(keys["ArrowDown"]){
        xzangle -= multiplier * 0.2;
    }
    if(keys["ArrowLeft"]){
        yangle -= multiplier;
    }
    if(keys["ArrowRight"]){
        yangle += multiplier;
    }
    if (yangle >= Math.PI){
        yangle = yangle - Math.PI*2
    }
    if (yangle <= -Math.PI){
        yangle = yangle + Math.PI*2
    }
    xzangle = Math.max(Math.min(xzangle, 1), 0.1)
    yangle_out.innerHTML = (yangle * RADTODEG).toFixed(1) + "° from east"
    xzangle_out.innerHTML = (xzangle * RADTODEG).toFixed(1) + "°"
}

function step(delta: number){
    handleMovement(delta);
    for(const shell of shells){
        shell.step(delta * 2); //SORRY!
    }
    for(const unit of units){
        unit.step(delta);
    }
}

function fire(){
    if(!reloaded){
        return;
    }
    unloadShell()

    const power =  30

    const shell = new Shell(yangle, xzangle, player_x, 0, player_y, power)

    shells.push(shell)
}
fire_in.onclick = fire;

startCampaign();
checkForMessages();

setInterval(draw, 16);
setInterval(() => {
    step(0.016)
}, 16);